import React, { useState } from "react";
import "./faq.css";
import FAQ from '../images/faqColoured.png';
import Footer from "../components/Footer";
import { Helmet } from "react-helmet";

const Faq = () => {
    const [currentQuestion, setCurrentQuestion] = useState(null);

    const showAnswer = (question) => {
      setCurrentQuestion(currentQuestion === question ? null : question);
    };
  
    const questions = [
      "What is Zenker's Diverticulum?",
      "What causes Zenker's Diverticulum?",
      "What are the symptoms of Zenker's Diverticulum?",
      "How is Zenker's Diverticulum diagnosed?",
      "How is Zenker's Diverticulum treated?",
      "What are the risks of the endoscopic treatment option for Zenker's Diverticulum?",
      "What are the risks of the open surgery treatment option for Zenker's Diverticulum?",
      "What kind of diet do I need to follow when I go home after Zenker's Diverticulum surgery?",
      "Can I exercise after Zenker's Diverticulum surgery?",
      "What are unusual symptoms that I need to watch for after Zenker's Diverticulum surgery?",
    ];
  
    const answers = [
      "Zenker's diverticulum is a pouch that can form in the back of the throat, just above the esophagus. It occurs due to a weakness in the throat muscles and results in food getting trapped within this pouch. This can cause symptoms such as difficulty swallowing, regurgitation, bad breath, and coughing.",
      "It is caused by a weakness in two muscles found at the back of your throat, particularly between the cricopharyngeal and inferior pharyngeal constrictor muscles. Over time, increased pressure while swallowing can push the throat tissue through this weak area, which can result in the formation of a pouch.",
      "The most common symptoms of Zenker's Diverticulum include difficulty swallowing (dysphagia), regurgitation of food, noisy swallowing, and aspiration.",
      "The gold standard for diagnosing Zenker's Diverticulum is through the barium swallow radiography. This is when the patient drinks a liquid containing barium which coats the esophagus and throat and makes them visible on X-ray. This can reveal the size, shape, and position of the diverticulum.\nEndoscopy and CT scans can be used for diagnosis as they provide visualization of the throat and esophagus, but these tests are not always used.",
      "Treatment of Zenker's Diverticulum is surgical and can be done through either a minimally invasive endoscopic procedure or an open surgery approach. Both methods involve cutting a muscle in the throat to improve swallowing. The choice between the two treatments depends on the size of the diverticulum, prior treatments, and your personal health. Your doctor will assess which approach is safer and more effective for you.",
      "There is a higher chance of recurrence with endoscopic surgery. There is also a possibility that during endoscopy, the cutting of the cricopharyngeal muscle may not be complete and lead to persistent symptoms of difficulty swallowing. As a result, patients may need further treatment in the future. Another risk of this procedure includes esophageal perforation— in which a hole forms in the esophagus (tube that takes food and drinks to your stomach) and can lead to mediastinitis, the inflammation of the area between the lungs. Mediastinitis is a life-threatening infection. Other risks associated with the endoscopic surgery, though not common, are injuries to the teeth, lips, gums and jaw. There are also risks associated with the general anesthesia, including risks of heart attack, stroke, and death.",
      "The open surgery treatment option requires external incisions which may result in visible scarring on the neck. It can also lead to complications such as infection, bleeding, and nerve injury to the recurrent laryngeal nerve – which can leave the patient with a weak and breathy voice. Another risk of this surgery includes esophageal perforation, in which a hole forms in the esophagus and can lead to mediastinitis, the inflammation of the area between the lungs. Mediastinitis is a life-threatening infection. There are also risks associated with the general anesthesia, including risks of heart attack, stroke, and death. Following the procedure, there is a risk of persistent symptoms of difficulty swallowing and additional treatments may be required in the future.",
      "Once you go home, you will need to follow a soft food diet for 30 days to protect the healing area. Some examples of soft foods include mashed potatoes, scrambled eggs, smoothies, and soups. It is important to drink clear liquids, like water, to stay hydrated. Avoid hard or sharp foods that might scrape or damage the healing of the tissues.",
      "For the first few weeks after surgery, avoid heavy lifting and strenuous activity. These activities can increase the pressure in your neck and throat, which might disrupt healing or lead to bleeding under the skin.",
      "Please report to your doctor immediately if you feel any unusual symptoms after the surgery such as difficulty swallowing, vomiting, excessive coughing during meals, new chest or back pain, or signs of infection, including redness, swelling around the surgical site, and fever.",
    ]

    return (
      <div>
        <div>
          <Helmet>
            <title>FAQ | ENT Chatbot</title>
          </Helmet>
        </div>
        <div className="faq-box">
        <div className="faq-header">
          <img src={FAQ} className="iconFAQ" />
          <h1> Frequently Asked Questions </h1>
        </div>
        <h1 class = "subheading-text-faq"> Answers to commonly asked questions </h1>
        <div class = "line-faq">
          <hr></hr>
        </div>
        <ul class = "listFAQ">
          {questions.map((currentQ, question) => (
            <li key={question} className="question-box">
              <button
                className={`question ${
                  currentQuestion === question ? "active" : ""
                }`}
                onClick={() => showAnswer(question)}
              >
                {currentQ}
                <span className="triangle">
                  {currentQuestion === question ? "▴" : "▾"}
                </span>
              </button>
              {currentQuestion === question && (
                <div className="answer">
                  <p>{answers[question]}</p>
                </div>
              )}
            </li>
          ))}
        </ul>
        </div>
        <Footer/>

      </div>
    );
  };
  
  export default Faq;